import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class PostingsRecommendedRoute extends Route {
  @service router;

  /**
   * This route was moved.
   */
  redirect() {
    return this.router.replaceWith(EMBER_ROUTE_NAMES.POSTINGS__FIND_WORK__RECOMMENDED);
  }
}

export default PostingsRecommendedRoute;
